import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { PROSPECT_ITEM_CUSTOMER_CODE } from "v4/data/apiRoutes";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import { resolveUrl } from "v4/features/front/navigation/utils/route.utils";
import useFetch from "v4/hooks/useFetch";
import { generateUrl } from "v4/services/api.service";
import Loader from "../../v4/components/ui/Loader/Loader";
import { Error404 } from "../Error/404";

export default function CustomerCodeProspectLoader() {
    const { currentRoute, getRouteByNativeIdentifier, getDefaultProspectTab } = useNavigation();
    const { customerCode } = currentRoute.params;
    const [{ data, isFinished, errorData }, fetchProspects] = useFetch();
    const { replace } = useHistory();

    useEffect(() => {
        fetchProspects({
            url: generateUrl(PROSPECT_ITEM_CUSTOMER_CODE, { customerCode })
        });
    }, [customerCode, fetchProspects]);

    useEffect(() => {
        if (isFinished && data) {
            const prospectId = data?.data?.id;
            replace(prospectId
                ? `/${resolveUrl(getDefaultProspectTab().url, { prospect: prospectId })}`
                : `/${generateUrl(getRouteByNativeIdentifier('main_prospects').url)}`
            );
        }
    }, [isFinished, data, replace, getRouteByNativeIdentifier, getDefaultProspectTab]);

    if (!isFinished) {
        return <Loader className={"admin-loader"}/>;
    }

    if (errorData?.message === 'prospect_item_not_found_msg') {
        return <Error404/>;
    }

    return null;
}
